module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "upload-documents"
    }
  }, [_c('div', {
    staticClass: "level-right",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.isAdmin) ? _c('div', {
    staticClass: "level-item"
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "expanded": true
    },
    model: {
      value: (_vm.selectedFilterUser),
      callback: function($$v) {
        _vm.selectedFilterUser = $$v
      },
      expression: "selectedFilterUser"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- All Users --")]), _vm._v(" "), _vm._l((_vm.allUsers), function(user, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": user.email
      }
    }, [_vm._v("\n                        " + _vm._s(user.displayName) + " (" + _vm._s(user.email) + ")\n                    ")])
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('option', {
    attrs: {
      "value": "1000"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 per page")])])], 1)], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.myUploadFiles,
      "paginated": _vm.isPaginated,
      "stickyHeaders:": "",
      "true": "",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "default-sort-direction": _vm.defaultSortDirection,
      "default-sort": "timeCreated",
      "opened-detailed": _vm.defaultOpenedDetails,
      "detailed": "",
      "detail-key": "id"
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "visible": false
          }
        }, [_vm._v("\n                " + _vm._s(props.row.id) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "fileName",
            "label": "File Name",
            "sortable": ""
          }
        }, [_c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.originalFile) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "timeCreated",
            "label": "Creation Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.timeCreated).toLocaleDateString()) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "timeExpired",
            "label": "Expiration Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.timeExpired).toLocaleDateString()) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "fileExt",
            "label": "Type",
            "sortable": "",
            "right": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                    " + _vm._s(props.row.fileExt) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "size",
            "label": "Size",
            "sortable": "",
            "numeric": ""
          }
        }, [_c('span', {
          staticClass: "tag",
          staticStyle: {
            "background-color": "initial"
          }
        }, [_vm._v("\n                    " + _vm._s(Math.ceil(props.row.size / 1000)) + "KB\n                ")])])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('article', {
          staticClass: "media"
        }, [_c('figure', {
          staticClass: "media-left"
        }, [_c('p', {
          staticClass: "image is-96x96"
        }, [_c('img', {
          attrs: {
            "src": '/static/img/icons/512px/' + props.row.fileExt.toLowerCase() + '.png',
            "alt": props.row.fileName
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('h4', {
          staticClass: "title is-4",
          staticStyle: {
            "margin-top": "0",
            "margin-bottom": "5px"
          }
        }, [_c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                                    " + _vm._s(props.row.originalFile) + "\n                                ")]), _vm._v(" "), _c('small', [_vm._v("\n                                    ("), _c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.row.fileName))]), _vm._v(")\n                                ")])]), _vm._v(" "), _c('em', [_vm._v("\n                                Uploaded By\n                                    "), (props.row.photoURL) ? _c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": props.row.photoURL,
            "alt": "",
            "width": "16"
          }
        }) : _vm._e(), _vm._v(" "), (props.row.displayName) ? _c('strong', [_vm._v(_vm._s(props.row.displayName))]) : _c('strong', [_vm._v("You")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("ago")(props.row.timeCreated)))])]), _vm._v(" "), _c('p', [_c('em', {
          domProps: {
            "innerHTML": _vm._s(_vm.newline_to_br(props.row.notes))
          }
        })])])])])]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_c('b-table-column', {
    attrs: {
      "field": "fileName",
      "label": "File Name"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "timeCreated",
      "label": "Creation Date"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "timeExpired",
      "label": "Expiration Date"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "fileExt",
      "label": "Type"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "size",
      "label": "Size"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c('p', [_vm._v("There are no recent files.")])])])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26f963c5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client_portal/UploadTable.vue
// module id = 507
// module chunks = 1